module.exports = __webpack_public_path__ + "assets/img/landing-desktop-23e2c3e0.jpg";